export function isMobileAgent(): boolean {
  return !!(
    navigator.userAgent.match(/Android|iPhone|iPad|iPod/i) ||
    (navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 1 &&
      /MacIntel/.test(navigator.platform))
  ); // iPad Pro
}
